const LanguageSupportMixin = {
  wrapUrlSafe(url, languageRegionCode) {
    if (languageRegionCode) {
      const code = languageRegionCode.split('-')[0];
      if (code.toLowerCase() !== 'en') {
        return `/${code}${url}`;
      }
      return url;
    }
    if (typeof window === 'undefined') {
      var window = this;
    }
    if (window && window.checkLinkAndAppendLanguage) {
      return window.checkLinkAndAppendLanguage(url);
    }
    return url;
  }
};

export { LanguageSupportMixin };
